module.exports = __webpack_public_path__ + "assets/static/media/opusMobileInfo.177febd9.png";